<script lang="ts">
  import type { DefaultCardResult } from "./defaultCard";

  export let result: DefaultCardResult;
</script>

<div
  class="share-frame"
  style="width: 540px; height: 1170px; padding: 56px 40px 64px; background: radial-gradient(ellipse 70% 50% at 18% 6%, rgba(245, 158, 11, 0.22), transparent 60%), radial-gradient(ellipse 60% 40% at 96% 100%, rgba(245, 158, 11, 0.12), transparent 60%), linear-gradient(180deg, #0d1018 0%, #15171f 60%, #0d1018 100%); color: #f5f0e6; font-family: Inter, ui-sans-serif, system-ui, 'PingFang SC', 'Hiragino Sans GB', sans-serif; box-sizing: border-box; display: flex; flex-direction: column; gap: 28px;"
>
  <header style="display: flex; align-items: center; justify-content: space-between;">
    <span style="font-size: 12px; font-weight: 700; letter-spacing: 0.18em; color: #f59e0b; text-transform: uppercase;">
      ✦ 魔法小卡 · 我的默认卡
    </span>
    <span style="font-size: 11px; color: #8a8472; letter-spacing: 0.05em;">
      {new Date().toLocaleDateString("zh-CN")}
    </span>
  </header>

  {#if result.card}
    <section
      style="background: rgba(245, 158, 11, 0.05); border: 1.5px solid rgba(245, 158, 11, 0.35); border-radius: 28px; padding: 36px 32px; flex: 1; display: flex; flex-direction: column; gap: 26px; box-shadow: 0 30px 70px -30px rgba(245, 158, 11, 0.45), inset 0 1px 0 rgba(245, 158, 11, 0.15);"
    >
      <p style="font-size: 11px; font-weight: 700; letter-spacing: 0.22em; color: #f59e0b; text-transform: uppercase; margin: 0;">
        随手刷，用这张
      </p>

      <div style="display: flex; align-items: center; gap: 22px;">
        {#if result.card.imageUrl}
          <img
            src={result.card.imageUrl}
            alt=""
            style="width: 140px; height: 90px; object-fit: cover; border-radius: 14px; border: 1px solid rgba(245, 158, 11, 0.2); box-shadow: 0 18px 36px -10px rgba(0,0,0,0.6); transform: perspective(700px) rotateY(-9deg) rotateX(3deg);"
          />
        {:else}
          <div
            style="width: 140px; height: 90px; border-radius: 14px; border: 1px solid rgba(245, 158, 11, 0.2); background: linear-gradient(135deg, rgba(245, 158, 11, 0.45), rgba(245, 158, 11, 0.08)); display: flex; align-items: center; justify-content: center; font-size: 26px; font-weight: 800; color: #f59e0b; box-shadow: 0 18px 36px -10px rgba(0,0,0,0.6); transform: perspective(700px) rotateY(-9deg) rotateX(3deg);"
          >
            {result.card.shortName.slice(0, 2)}
          </div>
        {/if}
        <div style="min-width: 0; flex: 1;">
          <h1 style="font-size: 48px; font-weight: 800; line-height: 1.05; margin: 0; letter-spacing: -0.02em; color: #faf7ef;">
            {result.card.shortName || result.card.name}
          </h1>
          <p style="margin: 10px 0 0; font-size: 14px; color: #b3aa97;">
            {result.card.issuer} · {result.card.level}
          </p>
        </div>
      </div>

      <div
        style="background: rgba(245, 158, 11, 0.1); border: 1px solid rgba(245, 158, 11, 0.25); border-radius: 18px; padding: 22px 24px;"
      >
        <p style="font-size: 10px; font-weight: 700; letter-spacing: 0.22em; color: rgba(245, 158, 11, 0.85); text-transform: uppercase; margin: 0;">
          支付方式
        </p>
        <p style="font-size: 22px; line-height: 1.35; font-weight: 700; color: #faf7ef; margin: 8px 0 0;">
          {result.payHint}
        </p>
        <p style="font-size: 13px; color: #b3aa97; margin: 10px 0 0;">
          因为它有：{result.reason.replace(/^因为它有：/, "")}
        </p>
      </div>
    </section>

    {#if result.exceptions.length > 0}
      <section
        style="background: rgba(255, 255, 255, 0.02); border: 1px dashed rgba(245, 158, 11, 0.25); border-radius: 22px; padding: 24px 24px 22px;"
      >
        <p style="font-size: 11px; font-weight: 700; letter-spacing: 0.18em; color: #b3aa97; text-transform: uppercase; margin: 0 0 14px;">
          ⚠ 例外 · 背下来 {result.exceptions.length} 条
        </p>
        <ul style="margin: 0; padding: 0; list-style: none; display: flex; flex-direction: column; gap: 12px;">
          {#each result.exceptions as ex}
            <li style="display: flex; align-items: center; gap: 12px; font-size: 14px;">
              <span style="font-size: 22px;">{ex.emoji}</span>
              <span style="font-weight: 600; color: #faf7ef; width: 76px;">{ex.scenario}</span>
              <span style="color: #6b665a;">→</span>
              <span style="background: rgba(245, 158, 11, 0.18); color: #f59e0b; padding: 5px 14px; border-radius: 999px; font-size: 12px; font-weight: 700; letter-spacing: 0.02em;">
                {ex.card.shortName || ex.card.name}
              </span>
              <span style="color: #8a8472; font-size: 11px; flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                {ex.benefit.title}
              </span>
            </li>
          {/each}
        </ul>
      </section>
    {:else}
      <section
        style="background: rgba(255, 255, 255, 0.02); border: 1px dashed rgba(245, 158, 11, 0.25); border-radius: 22px; padding: 28px; text-align: center;"
      >
        <p style="font-size: 14px; color: #b3aa97; margin: 0;">
          没有例外。任何消费都用默认卡，别想了。
        </p>
      </section>
    {/if}
  {/if}

  <footer style="text-align: center; font-size: 11px; color: #6b665a; letter-spacing: 0.18em; text-transform: uppercase;">
    ✦ 截图存壁纸 · 不用再打开 App ✦
  </footer>
</div>
